module.exports = __webpack_public_path__ + "static/media/PLN.02e2ee07.png";